var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    viewBox: "14 101 472 297.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M481.1,127.5c-3-1.8-6.8-1.9-9.9-0.2l-108.3,59.1V151c0-27.6-22.4-50-50-50H64c-27.6,0-50,22.4-50,50v197.4   c0,27.6,22.4,50,50,50h248.9c27.6,0,50-22.4,50-50v-34.8l108.3,59.1c3.1,1.7,6.9,1.6,9.9-0.2c3-1.8,4.9-5.1,4.9-8.6V136.1   C486,132.6,484.1,129.3,481.1,127.5L481.1,127.5z M342.9,348.4c0,16.6-13.4,30-30,30H64c-16.6,0-30-13.4-30-30V151   c0-16.6,13.4-30,30-30h248.9c16.6,0,30,13.4,30,30L342.9,348.4z M466,347.1l-103.1-56.3v-81.5L466,153V347.1z M466,347.1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamera);
export default __webpack_public_path__ + "static/media/video-camera.d77932e76343be5dde6796b7e99c29f9.svg";
export { ForwardRef as ReactComponent };